module.exports = __webpack_public_path__ + "img/emma_drink.843db482.svg";